import type { FC } from 'react'
import { useRef, useState, useEffect } from 'react'

import BenefitModal from './BenefitModalSlide'
import './clubeStyles.scss'

type BenefitsImg = {
  imageBenefit: string
  imgBenefitMobile: string
  modalContent: any
}

interface BenefitsSlideImgProps {
  items: BenefitsImg[]
}

const BenefitsSlideImg: FC<BenefitsSlideImgProps> = ({ items }) => {
  const listRef = useRef<HTMLDivElement>(null)
  const [current, setCurrent] = useState(0)
  const [modalContent, setModalContent] = useState(null)

  const handleSelect = (benefit: any) => setModalContent(benefit)
  const handleClose = () => setModalContent(null)

  useEffect(() => {
    document.body.style.overflow = modalContent ? 'hidden' : 'auto'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [modalContent])

  const extendedItems = [...items.slice(-2), ...items, ...items.slice(0, 2)]

  useEffect(() => {
    if (!listRef.current) {
      return
    }

    const container = listRef.current
    const firstRealIndex = 2
    const itemWidth = container.offsetWidth * 0.8

    container.scrollLeft = firstRealIndex * itemWidth
    setCurrent(0)
  }, [items])

  const handleScroll = () => {
    if (!listRef.current) {
      return
    }

    const container = listRef.current
    const itemWidth = container.offsetWidth * 0.8
    const index = Math.round(container.scrollLeft / itemWidth)
    const realIndex = index - 2

    setCurrent((realIndex + items.length) % items.length)

    if (index >= items.length + 2) {
      container.scrollLeft = 2 * itemWidth
    } else if (index <= 1) {
      container.scrollLeft = (items.length + 1) * itemWidth
    }
  }

  return (
    <>
      <div className="block md:text-center mb-[90px] md:items-center md:mb-[160px] font-inter">
        <h2 className="mb-[24px] text-[24px] leading-[40px] text-left max-w-[335px] px-[20px] md:text-center md:mb-[72px] md:text-[32px] md:leading-[40px] md:max-w-none md:px-0 font-medium">
          Ganhe descontos e benefícios exclusivos.
        </h2>

        <div className="flex flex-col md:justify-center md:flex-row md:gap-[40px]">
          {/* Desktop layout */}
          <div className="hidden md:flex md:gap-[40px]">
            {items.map((item, index) => (
              <div
                key={index}
                className="item-slide-benefit block relative overflow-hidden group mt-auto"
              >
                <button onClick={() => handleSelect(item.modalContent)}>
                  <picture>
                    <source
                      media="(max-width: 767px)"
                      srcSet={item.imgBenefitMobile}
                    />
                    <img
                      src={item.imageBenefit}
                      alt="banner-img-benefits"
                      className={`item-slide-benefit-img cursor-pointer ${
                        index !== 1
                          ? 'md:h-[427px] md:w-[381px]'
                          : 'md:h-[590px] md:w-[441px]'
                      }`}
                    />
                  </picture>
                </button>
              </div>
            ))}
          </div>

          {/* Mobile layout */}
          <div
            className="block md:hidden overflow-x-scroll no-scrollbar relative pb-[24px] benefitSlide"
            ref={listRef}
            onScroll={handleScroll}
          >
            <div className="flex" style={{ scrollSnapType: 'x mandatory' }}>
              {extendedItems.map((item, index) => (
                <div
                  key={index}
                  className={`flex-shrink-0 w-[80%] transition-all duration-500 ease-in-out snap-center ${
                    (index - 2 + items.length) % items.length === current
                      ? 'z-20 scale-100 opacity-100'
                      : 'z-10 scale-90 opacity-70'
                  }`}
                  style={{ scrollSnapAlign: 'center' }}
                >
                  <button onClick={() => handleSelect(item.modalContent)}>
                    <picture>
                      <source
                        media="(min-width: 768px)"
                        srcSet={item.imageBenefit}
                      />
                      <img
                        src={item.imgBenefitMobile}
                        alt="banner-img-benefits"
                        className="w-full h-auto block"
                      />
                    </picture>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {modalContent && (
        <BenefitModal modalContent={modalContent} onClose={handleClose} />
      )}
    </>
  )
}

export default BenefitsSlideImg
